import {
  DeleteButton,
  SaveButton,
  Toolbar,
  SimpleForm,
  type SimpleFormProps,
} from "react-admin";
import { layout } from "./tokens";
import { Box, Stack, type StackProps } from "@mui/material";

type Props = SimpleFormProps;

type ToolbarProps = {
  showDelete?: boolean;
  deleteMutationMode?: "undoable" | "pessimistic" | "optimistic";
};

export const AppFormToolbar: React.FC<ToolbarProps> = ({
  showDelete = true,
  deleteMutationMode = "undoable",
}) => (
  <Toolbar
    sx={{
      px: 0,
      py: 0,
      mt: layout.section.gap,
      backgroundColor: "transparent",
      borderTop: "1px solid",
      borderColor: "divider",
    }}
  >
    <Box
      sx={{
        display: "flex",
        width: "100%",
      }}
    >
      {showDelete ? <DeleteButton mutationMode={deleteMutationMode} /> : null}
      <Box sx={{ flex: 1 }} />
      <SaveButton variant="contained" />
    </Box>
  </Toolbar>
);

export function AppSimpleForm(props: Props) {
  return (
    <SimpleForm
      {...props}
      toolbar={props.toolbar ?? <AppFormToolbar />}
      sx={{
        "& .RaSimpleForm-form": {
          maxWidth: "none",
        },
        "& .MuiFormInput-root": {
          minWidth: 0,
        },
        rowGap: layout.section.gap,
      }}
    />
  );
}

export function AppFormSection({ children, ...props }: StackProps) {
  return (
    <Stack
      spacing={layout.form.sectionGap}
      sx={{
        width: "100%",
        "&:not(:last-child)": {
          mb: layout.section.gap,
        },
      }}
      {...props}
    >
      {children}
    </Stack>
  );
}

type AppFormContentProps = {
  children: React.ReactNode;
  maxWidth?: number | string;
};

export function AppFormContent({
  children,
  maxWidth = layout.form.contentWidth,
}: AppFormContentProps) {
  return (
    <Box sx={{ width: "100%", maxWidth }}>
      <Stack spacing={layout.form.fieldGap}>{children}</Stack>
    </Box>
  );
}
